module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_1001366.b9487149.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSatF/FormatoSimplificado_1001366.pdf
// module id = 350
// module chunks = 0